export default __webpack_public_path__ + "static/media/header-m.f78c1863.png";